<template>
  <div>
    <template v-if="isLoading">
    </template>
    <template v-else>
      <template v-if="deliveryNotes.length === 0">
        <b-alert variant="info" show>
          Noch keine Lieferscheine vorhanden.
        </b-alert>
      </template>
      <template v-else>
        <div v-for="note in deliveryNotes" :key="note.id" class="delivery-note">
          <h3>Lieferschein-Nummer {{ note.externalId }}</h3>
          <div v-for="propertyName in Object.keys(getPropertyDefinitions)" :key="propertyName" class="row mb-2">
            <div class="col-2">
              {{ getPropertyDefinitions[propertyName].translations[$i18n.locale].name }}
            </div>
            <div class="col-10">
              {{ valueFormatter(definition, propertyName, note[propertyName]).html }}
            </div>
          </div>

          <h4>Enthaltene Artikel</h4>
          <delivery-note-items-table :note="note" />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { valueFormatter } from '@/assets/js/helper/entity'
import DeliveryNoteItemsTable from '@/components/entity/DeliveryNoteItemsTable.vue'
import MixinEntityBase from '@/components/mixins/EntityBase'
import moment from 'moment'

export default {
  name: 'Orders.DeliveryNotes',
  mixins: [MixinEntityBase],
  components: {
    DeliveryNoteItemsTable
  },
  data () {
    return {
      isLoading: true,
      entityKey: 'deliverynotes'
    }
  },
  computed: {
    getPropertyDefinitions () {
      return this.definition.properties.filter(prop => !prop.settings.hidden).sort((a, b) => a.settings.order - b.settings.order).reduce((acc, prop) => {
        acc[prop.name] = {
          translations: prop.translations,
          readonly: prop.settings.readonly,
          hidden: prop.settings.hidden,
          order: prop.settings.order
        }
        return acc
      }, {})
    },
    definition () {
      return this.$store.getters[`${this.eCurrent.key}/definition`]
    },
    deliveryNotes () {
      return this.$store.getters[`${this.eCurrent.key}/getDeliveryNotes`]
    }
  },
  methods: {
    valueFormatter,
    getDeliveryNotes () {
      this.$store.dispatch(`${this.eCurrent.key}/getDefinition`)
      this.$store.dispatch(`${this.eCurrent.key}/loadDeliveryNotes`, {
        orderId: this.eParent.id
      }).finally(() => {
        this.isLoading = false
      })
    },
    formatDate (date) {
      return moment(date).format('DD.MM.YYYY HH:mm')
    }
  },
  mounted () {
    this.getDeliveryNotes()
  }
}
</script>

<style lang="scss">
.delivery-note {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ddd;
}

.delivery-note-item {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #eee;
}
</style>
